import { configurationStepSchema } from 'src/features/programsV2/schemas/configurationStepSchema';

import { Program } from '../../../types/program';
import { formatConfigurationStepValues } from './formatConfigurationStepValues';

export const verifyCompletedConfigurationStep = async (
  program?: Program | null
) => {
  if (!program) return false;

  const formattedValues = formatConfigurationStepValues(program);
  try {
    await configurationStepSchema.validate(formattedValues, {
      abortEarly: false,
    });
    return true;
  } catch (error) {
    return false;
  }
};
